import React from "react";
import SupportCategory from "./Models/SupportCategory";
import {
  ScrollToCategoryTag,
  SupportCategoryTagWithHash,
} from "./SupportCategoryFunctions";

export interface FormProps {
  categories: SupportCategory[];
}

export type Props = FormProps;

export default function SupportSidebarSticky({ categories }: Props) {
  return (
    <>
      <p className="support-label faq-cat pt-3" id="FAQ-categories-header">
        FAQ Categories
      </p>
      <ul
        className="support-nav faq-cat"
        aria-labelledby="FAQ-categories-header"
      >
        {categories.map((category) => (
          <li key={category.id.toString()}>
            <a
              href={SupportCategoryTagWithHash(category.categoryName)}
              onClick={(e) => ScrollToCategoryTag(e, category.categoryName)}
            >
              {category.categoryName}
            </a>
          </li>
        ))}
      </ul>
    </>
  );
}
